import { render, staticRenderFns } from "./TopSmall.vue?vue&type=template&id=1770fc91&scoped=true&"
import script from "./TopSmall.vue?vue&type=script&lang=js&"
export * from "./TopSmall.vue?vue&type=script&lang=js&"
import style0 from "./TopSmall.vue?vue&type=style&index=0&id=1770fc91&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1770fc91",
  null
  
)

export default component.exports